import { useState, useEffect } from "react";
import { useSidebar } from "../../components/SidebarContext";

const useFullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isTableMainDivPresent, setIsTableMainDivPresent] = useState(false);
  // const { sideBarColl, setSideBarColl } = useSidebar();
  const sidebarContext = useSidebar();
  const sideBarColl = sidebarContext?.sideBarColl;
  const setSideBarColl = sidebarContext?.setSideBarColl;

  useEffect(() => {
    const checkForTableMainDiv = () => {
      const tableMainDiv = document.querySelector(".tablemaindiv");
      setIsTableMainDivPresent(!!tableMainDiv);
    };

    checkForTableMainDiv();
  }, []);

  const toggleFullscreen = (e) => {
    const closestClassElement = e.target.closest(".tablemaindiv");
    const mainElement = e.target.closest("#maincontent");

    if (!closestClassElement) {
      return;
    }

    setIsFullscreen((prevState) => !prevState);

    setSideBarColl(!sideBarColl);

    if (isFullscreen) {
      closestClassElement.classList.remove("tablescreenfull");
      closestClassElement.style.marginLeft = "0px";
      document.body.style.overflow = "";
    } else {
      closestClassElement.classList.add("tablescreenfull");
      closestClassElement.style.marginLeft = mainElement ? mainElement.style.marginLeft : "0px";
      // document.body.style.overflow = 'hidden';
    }
  };

  return { isFullscreen, toggleFullscreen, isTableMainDivPresent };
};

export default useFullscreenToggle;
